/**
 * Optional: see what network resources load after the intro loader ends.
 * Enable: add ?debugLoader=1 to the URL once, or in console:
 *   localStorage.setItem('DEBUG_LOADER', '1'); location.reload()
 * Disable: localStorage.removeItem('DEBUG_LOADER')
 */
export function registerLoaderEndDebug() {
  if (typeof window === "undefined" || typeof PerformanceObserver === "undefined") {
    return;
  }

  const enabled =
    window.location.search.includes("debugLoader=1") ||
    window.localStorage.getItem("DEBUG_LOADER") === "1";

  if (!enabled) {
    return;
  }

  const handler = () => {
    // Same timeline as Resource Timing entry.startTime (ms since navigation).
    const mark = performance.now();
    // eslint-disable-next-line no-console
    console.info(
      "[loader debug] loader:finished — logging resources that start after this (25s window)"
    );
    // eslint-disable-next-line no-console
    console.info(
      "[loader debug] Home lazy UI (Suspense): SliderSection, PortfolioIntro, PortfolioGrid, PlansSection, NexusBusinessSection, CustomizedOfferSection, ServiceSection, CareSection, FAQSection, ContactFooter, FloatingConsultation"
    );

    const seen = new Set();
    let observer;

    try {
      observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType !== "resource") continue;
          const { name, startTime, duration, initiatorType } = entry;
          if (seen.has(name)) continue;
          if (startTime < mark - 150) continue;
          seen.add(name);
          const short = name.length > 90 ? `…${name.slice(-88)}` : name;
          // eslint-disable-next-line no-console
          console.info(
            `[loader debug] +${(startTime - mark).toFixed(0)}ms`,
            initiatorType,
            short,
            `(${duration.toFixed(0)}ms)`
          );
        }
      });
      observer.observe({ type: "resource", buffered: false });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[loader debug] PerformanceObserver not available", e);
      return;
    }

    window.setTimeout(() => {
      try {
        observer.disconnect();
      } catch (_) {}
      // eslint-disable-next-line no-console
      console.info("[loader debug] stopped watching");
    }, 25000);
  };

  window.addEventListener("loader:finished", handler);
}
